import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;

  button {
    outline: none;
  }

  .left-container {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 0;

    img {
      height: 60px;
      width: 60px;
      border-radius: 50%;
      margin-right: 20px;
      object-fit: cover;
    }

    .info {
      display: flex;
      flex-direction: column;
      min-width: 0;

      strong {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: var(--black-3);
      }

      span {
        font-weight: normal;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 14px;
        color: var(--black-7);
      }
    }
  }

  .right-container {
    display: flex;
    align-items: center;
    gap: 8px;

    button {
      background: transparent;
      cursor: pointer;
      height: 32px;
      width: 32px;
      border-radius: 8px;

      color: var(--black-7);
      transition: 0.2s ease;

      display: flex;
      align-items: center;
      justify-content: center;

      :hover {
        background: var(--white-darker);
      }
    }

    #check-btn {
      width: auto;
      font-weight: 500;
      gap: 4px;
      padding: 4px 12px 4px 8px;
      border: 1px solid var(--primary);
      color: var(--primary);

      :hover {
        background: var(--primary);
        color: var(--white-darker);
      }
    }

    #x-btn {
      :hover {
        background: var(--danger-transparent);
        color: var(--danger);
      }
    }
  }
`;
